export const ERROR_CODE = {
  PHONE_EXISTED: 'otp_phone_existed',
  SESSION_LOCK: 'otp_session_locked',
  PERMANENT_LOCK: 'otp_permanent_locked',
  CHANGE_LIMIT: 'worker_phone_change_limited',
  INVALID_PHONE: 'twilio_invalid_parameter',
  OTP_REQUEST_LIMITED: 'otp_request_limited',
}
